/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable */
import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import LoggerMiddleware from './helper/LoggerMiddleware';
import appReducer from './reducers/appReducer';
import notificationsReducer from './reducers/notificationsReducer';

const middleware = [thunkMiddleware, LoggerMiddleware];


const store = createStore(combineReducers({
	appState: appReducer,
	notifications: notificationsReducer,
}), applyMiddleware(...middleware));

export default store;
